import React, { useCallback, useEffect, useRef, useState } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import AgGridTable from "../../utilities/AgGridTable";
import FormPageHeader from "../../utilities/FormPageHeader";
import { IconButton, Stack, Tab, Tabs } from "@mui/material";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { useNavigate } from "react-router-dom";
import data from "./data";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import RequestAssign from "./RequestAssign";
import jwtDecode from "jwt-decode";
import { makeStyles, styled } from "@mui/styles";
import clsx from "clsx";
import { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;
const spacePlanRevisionsUrl = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.spacePlanRevisions}`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .open, & .inProgress, & .review, & .complete": {
      borderRadius: "20px",
      fontSize: "10px !important",
      textAlign: "center",
      height: '19px',
      lineHeight: '19px',
      padding: '0px 10px',
      marginTop: '1px',
    },
    "& .open": {
      backgroundColor: "#0597EA",
    },
    "& .inProgress": {
      backgroundColor: "#EAAA05",
    },
    "& .review": {
      backgroundColor: "#B8B9B9",
    },
    "& .complete": {
      backgroundColor: "#09D404",
    },
  },
}));

const EditRenderer = (props) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleRequestAssign = () => {
    setOpen(true);
  };
  return (
    <>
      <IconButton onClick={handleRequestAssign}>
        <FuseSvgIcon size={18} color="action">
          heroicons-outline:user-add
        </FuseSvgIcon>
      </IconButton>
      <IconButton onClick={props.onRowDoubleClicked}>
        <FuseSvgIcon size={18} color="action">
        heroicons-outline:eye
        </FuseSvgIcon>
      </IconButton>
      <RequestAssign open={open} handleClose={handleClose} />
    </>
  );
};

export default function RequestList(props) {
  const classes = useStyles(props);
  const [tabValue, setTabValue] = useState("ALL");
  const [rowData, setRowData] = useState();
  const [filteredRows, setFilteredRows] = useState([]);
  const [error, setError] = useState();
  const rowsRef = useRef(null);
  const gridRef = useRef();
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);

  const [columnDefs, setColumnDefs] = useState([
    // {
    //   headerName: "Sno.",
    //   valueGetter: "node.rowIndex + 1",
    //   maxWidth: 100,
    //   cellRenderer: 'agGroupCellRenderer'
    // },
    { field: "dsTaskId", headerName: "Request .No", enableRowGroup: true, cellRenderer: 'agGroupCellRenderer', minWidth: 80, },
    { field: "partner", headerName: "Partners", enableRowGroup: true },
    { field: "showroom", headerName: "Showroom", enableRowGroup: true },
    { field: "designStudioCategory", headerName: "Type", enableRowGroup: true },
    { field: "createdDate", enableRowGroup: true, headerName: "Create Date" },
    { field: "assignees", enableRowGroup: true, headerName: "Assignee" },
    {
      field: "dsLifeCycle",
      enableRowGroup: true,
      headerName: "Status",
      valueFormatter: (params) => `${params.value.replace(/_/g, ' ')}`,
      cellClass: (params) => {
        if (
          params.value === "REQUEST_BRIEF" ||
          params.value === "REQUEST_BRIEF_REVIEW"
        ) {
          return "open";
        } else if (
          params.value === "SPACE_PLANNING" ||
          params.value === "INDIVIDUAL_KITCHEN_DESIGN"
        ) {
          return "inProgress";
        } else if (
          params.value === "SPACE_PLANNING_REVIEW" ||
          params.value === "INDIVIDUAL_KITCHEN_DESIGN_REVIEW"
        ) {
          return "review";
        } else if (params.value === "COMPLETED") {
          return "complete";
        }
        return null;
      },
    },
    {
      headerName: "Action",
      cellRenderer: (data) => <EditRenderer />,
    },
  ]);

  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const loadDate = async () => {
    try {
      const list = await OAuthService.getList(url + "?size=1000");
      let requestList = list.data?._embedded?.dsTaskAssignments;

      const userScope = token && token?.scope;
      if (userScope.includes("ROLE_DESGNSTHEAD")) {
        setRowData(requestList);
        setFilteredRows(requestList);
      } else {
        const currentUser = token && token?.preferred_username;
        const filteredRequestList = requestList.filter(
          (request) =>
            request.assignees?.includes(currentUser) ||
            request.createdByUser === token?.email
        );

        const anotherList = requestList.filter(
          (request) =>
            !request.assignees?.includes(currentUser) ||
            request.createdByUser !== token?.email
        );
        const filtered = anotherList
          .filter((f) =>
            f?.kitchenQuantities?.some((kq) =>
              kq?.assignToDesigners?.includes(currentUser)
            )
          )
          .map((f) => ({ ...f, readOnly: true }));

        setRowData([...filteredRequestList, ...filtered]);
        setFilteredRows([...filteredRequestList, ...filtered]);
        rowsRef.current = [...filteredRequestList, ...filtered]

      }
      // const requestByUser = requestList.filter(user => user.assignees)
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  const onGridReady = useCallback((params) => {
    // loadDate();
  }, []);

  useEffect(() => {
    loadDate();
  }, [])
  

  function handleTabChange(event, value) {
    const newRows = rowData?.filter(
      (d) => d?.dsStatus === value || value === "ALL"
    );
    console.log(newRows);
    setFilteredRows(newRows);
    setTabValue(value);
  }

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = (params) => {
    const { data } = params;
    const { dsTaskId, dsLifeCycle } = data;
    console.log('data', data)
    const userRoles = token?.scope;
    if (userRoles?.includes("ROLE_PARTNER_ADMIN")) {
      console.log('PARTNER')
      const paths = {
        REQUEST_BRIEF: "/design-studio/showroom-questionnaire/" + dsTaskId,
        REQUEST_BRIEF_REVIEW: "/design-studio/request-review/" + dsTaskId,
        SPACE_PLANNING: "/design-studio/space-planing-review/" + dsTaskId,
        SPACE_PLANNING_REVIEW:
          "/design-studio/space-planing-review/" + dsTaskId,
        INDIVIDUAL_KITCHEN_DESIGN:
          "/design-studio/individual-kitchen-design-review/" + dsTaskId,
        INDIVIDUAL_KITCHEN_DESIGN_REVIEW:
          "/design-studio/individual-kitchen-design-review/" + dsTaskId,
        COMPLETED: "/design-studio/request-summary/" + dsTaskId,
      };
      navigate(paths[dsLifeCycle]);
    } else if (
      userRoles?.includes("ROLE_DESGNSTHEAD") ||
      userRoles?.includes("ROLE_DESIGNER")
    ) {
      console.log('DESIGNER')
      const paths = {
        REQUEST_BRIEF: "/design-studio/showroom-questionnaire/" + dsTaskId,
        REQUEST_BRIEF_REVIEW: "/design-studio/request-review/" + dsTaskId,
        SPACE_PLANNING: "/design-studio/space-planing/" + dsTaskId,
        SPACE_PLANNING_REVIEW:
          "/design-studio/space-planing-review/" + dsTaskId,
        INDIVIDUAL_KITCHEN_DESIGN:
          "/design-studio/individual-kitchen-design/" + dsTaskId,
        INDIVIDUAL_KITCHEN_DESIGN_REVIEW:
          "/design-studio/individual-kitchen-design-review/" + dsTaskId,
        COMPLETED: "/design-studio/request-summary/" + dsTaskId,
      };
      navigate(paths[dsLifeCycle]);
    }
  };

  return (
    <>
      <FormPageHeader
        componentName="List"
        pageName="Request List"
        currentPage="Request List"
      >
        <Tabs
          value={tabValue}
          textColor="inherit"
          onChange={handleTabChange}
          indicatorColor="secondary"
          sx={{ color: "yellow" }}
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className={clsx(classes.root)}
        >
          <Tab label="All" value={"ALL"} sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Open" value={"REQUESTED"} sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="In Progress" value={"PROCESSED"} sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
          <Tab label="Completed" value={"COMPLETED"} sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
        </Tabs>
      </FormPageHeader>
      <div className={clsx(classes.root, "p-16 sm:p-24 h-full")}>
        <div className={"h-full"}>
          <AgGridTable
            rowData={filteredRows}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            gridRef={gridRef}
            onRowDoubleClicked={onRowDoubleClicked}
            onSelectionChanged={onSelectionChanged}
            groupCheckBox={true}
            hideCheckbox={true}
            editable={false}
            pagination={true}
          />
        </div>
      </div>
    </>
  );
}
